"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeRunStatus = void 0;
var FlowNodeRunStatus;
(function (FlowNodeRunStatus) {
    FlowNodeRunStatus["COMPLETED"] = "completed";
    FlowNodeRunStatus["FAILED"] = "failed";
    FlowNodeRunStatus["SKIPPED"] = "skipped";
})(FlowNodeRunStatus = exports.FlowNodeRunStatus || (exports.FlowNodeRunStatus = {}));
//# sourceMappingURL=flow-node-runs.js.map